import air1 from '../../assets/images/airports/solutions_airports-1.webp';
import air2 from '../../assets/images/airports/solutions_airports-2.webp';
import air3 from '../../assets/images/airports/solutions_airports-3.webp';
import air4 from '../../assets/images/airports/solutions_airports-4.webp';

const data = [air1, air2, air3, air4];

export default data;